export function getRuntimeEnv(): "dev" | "prod" | "staging" {
  const host = window.location.host;
  switch (host) {
    case "staging-szyt.yitutech.com":
    case "staging-szyt.yitu-inc.com":
    case "10.40.51.102":
      return "staging";
    case "szyt.yitu-inc.com":
    case "partner.yitutech.com":
      return "prod";
    default:
      return "dev";
  }
}
